export default __webpack_public_path__ + "static/media/CP_JC.75b924e8.png";